import { render } from "./slider.vue?vue&type=template&id=a5712bea&ts=true"
import script from "./slider.vue?vue&type=script&lang=ts"
export * from "./slider.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__